<template>
  <router-view />
</template>
<script>
  export default {
    name: 'FluxoCaixaModule',
  }
</script>
